import React, { useEffect, useState } from 'react';
import Piechart from "components/charts/PieChart";
import { HorizontalBarchart } from "components/charts/HorizontalBarchart";
import { useTestObjectRef, BI } from 'utils/testUtils';
import { useDispatch, useSelector, useStore } from "react-redux";
import { readcheckedfilterAllCompanyResultsByLawyerIds } from "state/actions/readCheckedActions";
import color from "../../utils/color";

const getLawyerPACount = (currentPracticeAreasResults, top) => {
    let practiceAreas = currentPracticeAreasResults.map(a => a.desc);
    let occurrences = {};
    for (let i = 0, j = practiceAreas.length; i < j; i++) {
        occurrences[practiceAreas[i]] = (occurrences[practiceAreas[i]] || 0) + 1;
    }
    let result = Object.entries(occurrences).map(([desc, count]) => ({ desc, count }));
    result.sort((a, b) => b.count - a.count);
    return result.slice(0, top);
}
const ReadCheckedPracticeAreaBi = ({ isOverlay = false, closeDialog, currentPaResults, chartType }) => {
    const [stats, setStats] = useState([]);
    const dispatch = useDispatch();
    const store = useStore();
    const BiValue = isOverlay ? BI.READ_CHECKED_OVERLAY_PRACTICE_AREAS_CHART : BI.READ_CHECKED_PRACTICE_AREAS_CHART;
    const chartRef = useTestObjectRef(BiValue);
    useEffect(() => {
        async function getStats() {
            if (currentPaResults) {
                let top = 5;
                if (isOverlay) {
                    top = currentPaResults.length;
                }
                let result = getLawyerPACount(currentPaResults, top);
                setStats(result);
            }
        }
        getStats();
    }, [currentPaResults]);
    const filterByLawyerIds = legendItem => {
        const result = store.getState().readchecked.readSelectedcurrentPAResults;
        if (result) {
            const lawyerIds = result.filter(item => item.desc === legendItem.text).map(item => item.lId);
            dispatch(readcheckedfilterAllCompanyResultsByLawyerIds(lawyerIds));
            if (isOverlay) {
                closeDialog();
            }
        }
    }

    return (
        <div
            id="readCheckedPracticeAreas"
        >
            {chartType === "Pie" && <Piechart
                label="Practice Areas"
                data={stats.map(item => item.count)}
                labels={stats.map(item => item.desc)}
                ref={chartRef}
                legendCallBack={(event, legendItem) => filterByLawyerIds(legendItem)}
                backgroundColors={[...color(stats.length)]} />
            }
            {chartType === "Bar" && <HorizontalBarchart
                label="Practice Areas"
                data={stats.map(item => item.count)}
                labels={stats.map(item => item.desc)}
                ref={chartRef}
                legendCallBack={(event, legendItem) => filterByLawyerIds(legendItem)}
                backgroundColors={[...color(stats.length)]} />
            }

        </div>
    );
};
export default ReadCheckedPracticeAreaBi;
